"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RiskObjectDisplay = function RiskObjectDisplay(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      children = _ref.children,
      onClick = _ref.onClick,
      hoverContent = _ref.hoverContent,
      hoverButton = _ref.hoverButton,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["title", "icon", "children", "onClick", "hoverContent", "hoverButton", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledRiskObjectDisplay, _extends({
    className: className,
    onClick: onClick
  }, otherProps), icon || title ? /*#__PURE__*/_react.default.createElement(Header, null, icon ? /*#__PURE__*/_react.default.createElement(IconWrapper, null, icon) : null, title ? /*#__PURE__*/_react.default.createElement(_Typography.H4, {
    larger: true
  }, title) : null) : null, children ? /*#__PURE__*/_react.default.createElement(Content, null, children) : null, onClick && hoverContent ? /*#__PURE__*/_react.default.createElement(Overlay, null, hoverButton ? /*#__PURE__*/_react.default.createElement(HoverButton, null, hoverButton) : null, hoverContent ? /*#__PURE__*/_react.default.createElement(HoverContent, null, hoverContent) : null) : null);
};

var Header = _styledComponents.default.div.withConfig({
  displayName: "Header"
})(["display:flex;justify-content:flex-start;align-items:center;padding:2.4rem;border-bottom:0.1rem solid #e4e4e4;"]);

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "IconWrapper"
})(["padding:0.8rem;margin-right:1.8rem;background-color:#c4c4c4;border-radius:0.5rem;svg path{fill:white;}"]);

var Content = _styledComponents.default.div.withConfig({
  displayName: "Content"
})(["padding:2.4rem;> *{margin-bottom:1.6rem;&:last-child{margin-bottom:0;}}"]);

var Overlay = _styledComponents.default.div.withConfig({
  displayName: "Overlay"
})(["position:absolute;top:0;right:0;bottom:0;left:0;background:", ";border-radius:0.5rem;display:flex;opacity:0;justify-content:center;align-items:center;flex-flow:column;cursor:pointer;transition:opacity 0.15s linear;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme ? theme.brand.primary : 'rgba(255, 128, 0, 0.9)';
});

var HoverButton = _styledComponents.default.div.withConfig({
  displayName: "HoverButton"
})(["margin-bottom:1.6rem;"]);

var HoverContent = _styledComponents.default.div.withConfig({
  displayName: "HoverContent"
})(["color:white;font-family:", ";font-weight:500;font-size:1.8rem;line-height:2.3rem;text-align:center;letter-spacing:0.01em;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
});

var StyledRiskObjectDisplay = _styledComponents.default.div.withConfig({
  displayName: "StyledRiskObjectDisplay"
})(["width:100%;background:white;border:0.1rem solid #f0f1f3;box-sizing:border-box;box-shadow:0 0 0.1rem rgba(0,0,0,0.04),0 0.2rem 0.6rem rgba(0,0,0,0.04),0 1rem 2rem rgba(0,0,0,0.04);border-radius:0.5rem;position:relative;&:hover{", "{opacity:1;}}"], Overlay);

RiskObjectDisplay.propTypes = {
  /** String to be displayed in the header of the element. */
  title: _propTypes.string,

  /** A React component to be displayed inside the button. (If using an icon from wg-fe-ui, set size to 20) */
  icon: _propTypes.element,

  /** Content to be shown in the body of the element. */
  children: _propTypes.node,

  /** Function to be ran when the element is clicked. */
  onClick: _propTypes.func,

  /** Text to be displayed in the overlay when the element is hovered. */
  hoverContent: _propTypes.string,

  /** Button to be displayed in the overlay when the element is hovered. */
  hoverButton: _propTypes.element,

  /** Extra classNames to be passed. */
  className: _propTypes.string,

  /** Adds extra props to the element. */
  otherProps: _propTypes.object
};
var _default = RiskObjectDisplay;
exports.default = _default;